import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=22b06ae4&scoped=true&"
import script from "./TopBar.vue?vue&type=script&setup=true&lang=js&"
export * from "./TopBar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b06ae4",
  null
  
)

export default component.exports